export default __webpack_public_path__ + "static/dotpattern1-95e346726852e747e53d149b9b53c664.svg";